import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import type { Product } from '@src/type/product'

export interface GetVendorProductDetailResponse extends Response {
	data: { product: Product | null }
}

export type SelectQuery = {
	productNo: string
}
export const getVendorProductDetail = async ({
	productNo,
}: SelectQuery): Promise<GetVendorProductDetailResponse> => {
	const response = await client.get<GetVendorProductDetailResponse>(
		`/vendors/products/${productNo}`,
	)

	return response.data
}
